import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setResponse } from "../Response/responseSlice";
import { setToast, setLoading, setModal } from "../uiSlice";
import {
  getCapacitacionesPresenciales,
  createCapacitacionPresencial,
  editCapacitacionPresencial,
} from "../../Services/capacitacion_presencial_service";
import { TOAST_DELAY, fileUri } from "../../Constantes/constants";
import { UploadFileS3 } from "../File/fileSlice";

const initialState = {
  capacitaciones: [],
  capacitacion: {
    id: 0,
    nombreCurso: "",
    institucion: "",
    fechaInicio: "",
    fechaFinalizacion: "",
    lugarImpartido: "",
    instructor: "",
    img: "",
    estado: 1,
    usuario: "",
  },
};

export const capacitacionesPresencialesSlice = createSlice({
  name: "capacitacionesPresenciales",
  initialState,
  reducers: {
    setCapacitaciones: (state, action) => {
      state.capacitaciones = action.payload;
    },
    setCapacitacion: (state, action) => {
      state.capacitacion = !action.payload
        ? initialState.capacitacion
        : action.payload;
    },
  },
});

export const fetchCapacitacionesPresenciales = createAsyncThunk(
  "capacitacionesPresenciales/fetchCapacitacionesPresenciales",
  async (_, { dispatch }) => {
    const capacitacionesRes = await getCapacitacionesPresenciales();
    dispatch(setCapacitaciones(capacitacionesRes));
  }
);

export const addCapacitacionPresencial = createAsyncThunk(
  "capacitacionesPresenciales/create",
  async (data, { dispatch }) => {
    dispatch(setLoading(true));
    const capacitacionRes = await createCapacitacionPresencial(data);
    dispatch(setResponse(capacitacionRes));
    dispatch(setLoading(false));

    if (Boolean(capacitacionRes.result)) {
      dispatch(setModal(false));
      dispatch(fetchCapacitacionesPresenciales());
    }

    dispatch(setToast(true));
    setTimeout(() => {
      dispatch(setToast(false));
    }, TOAST_DELAY);
  }
);

export const editCapacitacionPresencialThunk = createAsyncThunk(
  "capacitacionesPresenciales/update",
  async (data, { dispatch }) => {
    dispatch(setLoading(true));
    const capacitacionRes = await editCapacitacionPresencial(data);
    dispatch(setResponse(capacitacionRes));
    dispatch(setLoading(false));

    if (Boolean(capacitacionRes.result)) {
      dispatch(setModal(false));
      dispatch(fetchCapacitacionesPresenciales());
    }

    dispatch(setToast(true));
    setTimeout(() => {
      dispatch(setToast(false));
    }, TOAST_DELAY);
  }
);

export const mergeCapacitacionPresencial = createAsyncThunk(
  "capacitacionesPresenciales/merge",
  async (data, { dispatch }) => {
    dispatch(setLoading(true));

    const capacitacionRes = data.idCapacitacion
      ? await editCapacitacionPresencial(data)
      : await createCapacitacionPresencial(data);

    const hasNewFile = data.img && data.img instanceof File;
    if (capacitacionRes.result && hasNewFile) {
      const formData = new FormData();
      formData.append("file", data.img);
      formData.append("tipo", fileUri.contenido);
      formData.append(
        "name",
        `capacitacion_presencial_${capacitacionRes.data}.jpg`
      );
      await dispatch(UploadFileS3(formData));
    }

    dispatch(setResponse(capacitacionRes));
    dispatch(setLoading(false));

    if (Boolean(capacitacionRes.result)) {
      dispatch(setModal(false));
      dispatch(setCapacitacion(initialState.capacitacion));
      dispatch(fetchCapacitacionesPresenciales());
    }

    dispatch(setToast(true));
    setTimeout(() => {
      dispatch(setToast(false));
    }, TOAST_DELAY);
  }
);

export const { setCapacitaciones, setCapacitacion } =
  capacitacionesPresencialesSlice.actions;
export default capacitacionesPresencialesSlice.reducer;
